import {
  Navigate,
  Outlet,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import Layout from "../components/layouts";
import { AuthProvider } from "../contexts/AuthProvider";
import FormsListPage from "../pages/admin/forms-list";
import FormBuilderPage from "../pages/admin/form-builder";
import OrganisationsListPage from "../pages/admin/organisations";
import OrganisationDetailPage from "../pages/admin/organisations/detail";
import ExternalServicesPage from "../pages/admin/external-services";
import FormPage from "../pages/form-page";
import AnswerSharePage from "../pages/answer-share";
import ExternalSubmissionPage from "../pages/external-submission";
import LoginPage from "../pages/login";
import NotFoundPage from "../pages/not-found";
import PrivacyPage from "../pages/privacy";
import SuccessPage from "../pages/success";
import AdminLayout from "./AdminLayout";
import RequireAuth from "./RequireAuth";

function AppFrame() {
  return (
    <AuthProvider>
      <Layout>
        <Outlet />
      </Layout>
    </AuthProvider>
  );
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppFrame />}>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<AdminLayout />}>
          <Route path="/" element={<FormsListPage />} />
          <Route path="/admin" element={<Navigate to="/" replace />} />
          <Route path="/admin/forms" element={<Navigate to="/" replace />} />
          <Route path="/admin/forms/new" element={<FormBuilderPage />} />
          <Route
            path="/admin/forms/:formId/edit"
            element={<FormBuilderPage />}
          />
          <Route
            path="/admin/organisations"
            element={<OrganisationsListPage />}
          />
          <Route
            path="/admin/organisations/:organisationId"
            element={<OrganisationDetailPage />}
          />
          <Route
            path="/admin/external-services"
            element={<ExternalServicesPage />}
          />
        </Route>
      </Route>
      <Route path="/forms/answers/:token" element={<AnswerSharePage />} />
      <Route path="/submissions/:uuid" element={<ExternalSubmissionPage />} />
      <Route path="/forms/:formId" element={<FormPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>,
  ),
);

export default function AppRoutes() {
  return <RouterProvider router={router} />;
}
